<template>
  <div class="content">
    <div class="row">
      <div class="col-md-12">
        <div class="card ">
          <div class="card-header ">
            <h5 class="card-title">Predictions</h5>
          </div>
          <div class="card-body">
            <div class="row d-flex justify-content-between pb-3">
              <div class="col-md-8 col-sm-6">
                <date-range-picker
                    ref="picker"
                    opens="right"
                    :locale-data="{
                            firstDay: 1,
                            format: 'dd-mm-yyyy',
                          }"
                    :showDropdowns="true"
                    :autoApply="true"
                    v-model="dateRange"
                    @update="dateFilter($event)"
                    @toggle="true"
                    :linkedCalendars="true"
                    :date-format="dateFormat"
                >
                  <template
                      v-slot:sui-input="picker"
                  >
                    {{ picker.startDate | date }} - {{ picker.endDate | date}}
                  </template>
                </date-range-picker>
              </div>
              <div class="col-md-4 col-sm-6">
                <sui-form>
                  <sui-form-field class="text-right">
                    <input placeholder="Search" v-model="filter"/>
                  </sui-form-field>
                </sui-form>
              </div>
            </div>
            <loader v-show="loading"/>
            <vuetable ref="vuetable"
                      :api-url="url"
                      :append-params="moreParams"
                      :fields="fields"
                      :per-page="perPage"
                      track-by="id"
                      pagination-path=""
                      @vuetable:pagination-data="onPaginationData"
                      @vuetable:loading="onLoading"
                      @vuetable:loaded="onLoaded"
            >
              <template slot="league" slot-scope="props">
                <img class="img-fluid" style="width: 23px" :src="props.rowData.leagueLogo" :alt="props.rowData.leagueName"> {{ props.rowData.leagueName }}
              </template>
              <template slot="home" slot-scope="props">
                <img class="img-fluid" style="width: 23px" :src="props.rowData.homeTeamLogo" :alt="props.rowData.homeTeamName"> {{ props.rowData.homeTeamName }}
              </template>
              <template slot="away" slot-scope="props">
                <img class="img-fluid" style="width: 23px" :src="props.rowData.awayTeamLogo" :alt="props.rowData.awayTeamName"> {{ props.rowData.awayTeamName }}
              </template>
              <template slot="status" slot-scope="props">
                <sui-button v-if="parseInt(props.rowData.status) === 1" size="mini" color="green" content="Won" />
                <sui-button v-else-if="parseInt(props.rowData.status) === 2" size="mini" color="red" content="Lost" />
                <sui-button v-else-if="parseInt(props.rowData.status) === 3" size="mini" color="orange" content="Pending" />
                <sui-button v-else-if="parseInt(props.rowData.status) === 4" size="mini" color="blue" content="Postponed" />
                <sui-button v-else-if="parseInt(props.rowData.status) === 5" size="mini" color="grey" content="Abandoned" />
                <sui-button v-else-if="parseInt(props.rowData.status) === 6" size="mini" color="brown" content="Cancelled" />
                <sui-button v-else size="mini" color="black" content="Closed" />
              </template>
              <template slot="prediction" slot-scope="props">
                {{ props.rowData.prediction }} ({{ props.rowData.shortName }})
              </template>
              <template slot="score" slot-scope="props">
                {{ (props.rowData.homeScore || props.rowData.homeScore === 0 || props.rowData.homeScore === '0') ? props.rowData.homeScore : '?' }} - {{ (props.rowData.awayScore || props.rowData.awayScore === 0 || props.rowData.awayScore ==='0' ) ? props.rowData.awayScore : '?' }}
              </template>
            </vuetable>

            <div class="vuetable-pagination ui basic segment grid">
              <vuetable-pagination-info ref="paginationInfo"></vuetable-pagination-info>
              <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import VuetablePaginationInfo from "vuetable-2/src/components/VuetablePaginationInfo";
import loader from "@/components/loader";
import _ from "lodash";
import moment from "moment";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    loader,
    DateRangePicker,
  },
  name: "fixtures",

  data() {
    let startDate = new Date();
    let endDate = new Date();
    endDate.setDate(endDate.getDate() - 30);
    return {
      loading: true,
      fields: [
        {
          name: "country",
          title: "Country",
          titleClass: "",
          dataClass: "",
        },
        {
          name: "league",
          title: "League",
          titleClass: "",
          dataClass: "",
        },
        {
          name: "home",
          title: "Home Team",
          titleClass: "",
          dataClass: "",
        },
        {
          name: "away",
          title: "Away Team",
          titleClass: "",
          dataClass: "",
        },
        {
          name: "predictionType",
          title: "Prediction Type",
          titleClass: "",
          dataClass: "",
        },
        {
          name: "prediction",
          title: "Prediction",
          titleClass: "",
          dataClass: "",
        },
        {
          name: "odds",
          title: "Odds",
          titleClass: "",
          dataClass: "",
        },
        {
          name: "status",
          title: "Status",
          titleClass: "",
          dataClass: "",
        },
        {
          name: "date",
          title: "Start Time",
          formatter (value) {
            return moment(value).format('lll');
          },
        },
        {
          name: "score",
          title: "Results",
          titleClass: "",
          dataClass: "",
        },
      ],
      sortOrder: [
        {
          field: "created_at",
          direction: "desc"
        }
      ],
      dateRange: { startDate, endDate },
      moreParams: {
        start: "",
        filter: "",
        end: "",
        route: "predictions",
        method: "GET"
      },
      perPage: 10,
      url: this.$store.state.api,
      filter: "",
    };
  },

  methods: {
    //...mapActions(["getTransactions"]),
    dateFormat (classes, date) {
      if (!classes.disabled) {
        classes.disabled = date.getTime() > new Date()
      }
      return classes
    },
    dateFilter: function (event) {

      var vm = this;

      vm.moreParams.start = moment(event.startDate).format('YYYY-MM-DD')
      vm.moreParams.end = moment(event.endDate).format('YYYY-MM-DD')

      this.$refs.vuetable.refresh();
    },
    createdAt: function(value) {
      if (!value) {
        return "-";
      } else {
        return moment(value).format("h:mm a,DD MMM YYYY");
      }
    },

    reload(){
      this.$refs.vuetable.setData(this.data);
      this.$refs.vuetable.refresh();
    },
    onPaginationData(paginationData) {
      this.$refs.paginationInfo.setPaginationData(paginationData);
      this.$refs.pagination.setPaginationData(paginationData);
    },

    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    dataManager(sortOrder, pagination) {
      if (this.data.length < 1) return;

      let local = this.data;

      // sortOrder can be empty, so we have to check for that as well
      if (sortOrder.length > 0) {
        console.log("orderBy:", sortOrder[0].sortField, sortOrder[0].direction);
        local = _.orderBy(
            local,
            sortOrder[0].sortField,
            sortOrder[0].direction
        );
      }

      pagination = this.$refs.vuetable.makePagination(
          local.length,
          this.perPage
      );
      console.log('pagination:', pagination)
      let from = pagination.from - 1;
      let to = from + this.perPage;

      return {
        pagination: pagination,
        data: _.slice(local, from, to)
      };
    },
    onLoading() {
      this.loading = true;
    },
    onLoaded() {
      this.loading = false;
    },
  },
  watch: {
    filter: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.moreParams.filter = newVal;
        this.reload();
      }
    },
  },
};
</script>
<style>
td.vuetable-slot {
  overflow: visible !important;
}
.l-container-content{
  padding: 1.5em;
}

</style>
